import { apiGet } from './api';

export const searchService = {
    // Perform a global search across all entities
    search: async (query) => {
        try {
            const response = await apiGet(`search?query=${encodeURIComponent(query)}`);
            if (response.success) {
                return response.data || [];
            } else {
                console.error('Search failed:', response.message);
                return [];
            }
        } catch (error) {
            console.error('Error performing search:', error);
            return [];
        }
    }
};

export default searchService; 